import { Pause, Play, CheckCircle, Clock, Loader } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "../../SidebarContext";

const TaskHistoryPage = () => {
    const location = useLocation();
    const history = location.state?.history || [];
    const { isSidebarOpen } = useSidebar();
    const safeHistory = Array.isArray(history) ? history : [];
    // Format timestamp to 24-hour format
    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false, // ✅ Force 24-hour format
        });
    };

    // Pick icon based on event
    const getIcon = (event) => {
        switch (event) {
            case "pause":
                return <Pause size={14} className="text-yellow-600" />;
            case "play":
                return <Play size={14} className="text-green-600" />;
            case "completed":
                return <CheckCircle size={14} className="text-blue-600" />;
           case "inprogress":
            return <Loader size={14} className="text-purple-600 animate-spin" />;
        default:
            return <Clock size={14} className="text-gray-500" />;
        }
    };

    // Show newest first
    const sortedHistory = [...safeHistory].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );


    return (
        <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
            <div>
                <div className="oms-header">
                    <h1 className="dashboard-title"> Task History</h1>
                    
                  
                </div>

                {sortedHistory.length === 0 || sortedHistory === null ? (
                    <p className="text-xs text-gray-500 italic">
                        No history available
                    </p>
                ) : (
                    <div className="space-y-2">
                        {sortedHistory.map((entry, index) => (
                            <div
                                key={index}
                                className="flex items-start gap-2 text-xs border-l pl-2 border-gray-200 w-full"
                            >
                                {/* Icon */}
                                <div className="mt-0.5">
                                    {entry.title === "Completed"
                                        ? getIcon("completed")
                                        : entry.title === "Paused"
                                            ? getIcon("pause")
                                            : entry.title === "Continue Task"
                                                ? getIcon("play")
                                                : entry.title === "In Progress"
                                            ? getIcon("inprogress")
                                                : null}
                                </div>


                                {/* Details (max 3 lines, no truncate) */}
                                <div className="flex flex-col leading-tight w-full">
                                    <p className="font-medium text-gray-800">
                                        {entry.title}
                                    </p>
                                    <p className="text-gray-500">
                                        {formatTimestamp(entry.createdAt)}
                                    </p>
                                    {entry.notes && (
                                        <p className="text-gray-600 italic">
                                            Reason: {entry.notes}
                                        </p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TaskHistoryPage;
